import { UserDataForm } from "@/components";
import { PageLayout } from "@/components/layouts/PageLayout";
import { RegisterProvider } from "@/services/context/register";
import { useScrollToTop } from "@/services/hooks";

function UserData() {
    useScrollToTop();
    return (
        <RegisterProvider>
            <PageLayout
                title="Tus datos personales"
                description="Crearemos una cuenta con estos datos para que luego puedas revisar o editar tu suscripción"
                progress={80}
            >
                <UserDataForm />
            </PageLayout>
        </RegisterProvider>
    );
}

export default UserData;
